// Copyright (c) 2016 Wildcard Corp. www.wildcardcorp.com

import {Component, OnInit} from '@angular/core';
import {ViewEncapsulation} from '@angular/core';

@Component({
    selector: 'mainapp',
    styles: [require('../styles/common/global.scss')],
  	 encapsulation: ViewEncapsulation.None,
    template: `
      <div class="content">
        <router-outlet></router-outlet>
      </div>
      <app-footer></app-footer>
    `,
})
export class MainComponent {

}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./app/components/main.component.ts